
function SdErrorListCtrl(TranslationService) {
    var ctrl = this;

    this.close = function () {
        ctrl.msg = null;
    }

    this.hasErrors = function () {
        if (!ctrl.errors) {
            return false
        }
        return ctrl.errors.length || ctrl.errorMsg != '';
    }
}

SdErrorListCtrl.$inject = ['TranslationService'];

seedWebApp.component('sdErrorList', {
    controller: SdErrorListCtrl,
    controllerAs: 'ctrl',
    bindings: {
        errors: '<',
    },
    templateUrl: '/SPA/Components/sd-error-list.html' + seedWebApp.buildVersion
});